export const SearchIconV2 = (props) => (
	<svg
		fill="none"
		height={17}
		viewBox="0 0 17 17"
		width={17}
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M15.832 15.8333L10.832 10.8333M12.4987 6.66659C12.4987 7.43263 12.3478 8.19117 12.0547 8.89891C11.7615 9.60664 11.3318 10.2497 10.7902 10.7914C10.2485 11.333 9.60542 11.7627 8.89768 12.0559C8.18995 12.349 7.43141 12.4999 6.66536 12.4999C5.89932 12.4999 5.14078 12.349 4.43304 12.0559C3.72531 11.7627 3.08225 11.333 2.54057 10.7914C1.9989 10.2497 1.56922 9.60664 1.27607 8.89891C0.982915 8.19117 0.832031 7.43263 0.832031 6.66659C0.832031 5.11949 1.44661 3.63576 2.54057 2.5418C3.63454 1.44783 5.11827 0.833252 6.66536 0.833252C8.21246 0.833252 9.69619 1.44783 10.7902 2.5418C11.8841 3.63576 12.4987 5.11949 12.4987 6.66659Z"
			stroke="#A0A5AF"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={1.66667}
		/>
	</svg>
);
